import { Analytic } from './analytic';

export class UpdateAnalyticRequest {
    analytic: Analytic;
    publishedSellerIds: number[];
    updatePermissionsOnly: boolean;
}
